export const onLoadChannel = payload => ({
    type: 'ON_LOAD_CHANNEL',
    payload,
})

export const onChange = payload => ({
    type: 'ON_CHANGE_CHANNEL',
    payload,
})

export const onVerifyChannel = payload => ({
    type: 'ON_VERIFY',
    payload,
})

export const onConnectAmazonFailure = payload => ({
    type: 'ON_CONNECT_AMAZON_FAILURE'
})

export const onSaveChannel = payload => ({
    type: 'ON_SAVE_CHANNEL',
    payload,
})

export const onSaveSuccess = payload => ({
    type: 'SAVE_CHANNEL_SUCCESS',
    payload,
})

export const onSaveFailure = payload => ({
    type: 'SAVE_CHANNEL_FAILURE',
    payload,
})

export const onVerifySuccess = payload => ({
    type: 'VERIFY_SUCCESS',
    payload,
})

export const onVerifyFailure = payload => ({
    type: 'VERIFY_FAILURE',
    payload,
})

export const onOk = () => ({
    type: 'ON_OK_CHANNEL',
})
export const onException = payload => ({
    type: 'ON_EXCEPTION',
    payload,
})



// WEBPACK FOOTER //
// ./src/actions/settingChannelAction.js